import { Link } from "react-router-dom";
import { Info } from "lucide-react";

export const PausedCategoryNotice = ({ name = "Artificial grass" }) => (
  <div className="rounded-2xl border border-amber-200 bg-amber-50 p-5 text-slate-700" data-testid="category-paused-notice">
    <p className="font-semibold text-slate-900 flex items-center gap-2">
      <Info className="w-4 h-4 text-amber-600" aria-hidden="true" /> {name} isn't currently offered on FloorMatch
    </p>
    <p className="text-sm mt-1.5">
      We're focusing on carpet, vinyl, laminate, LVT and carpet tiles for now.
    </p>
    <Link to="/search" className="inline-block mt-3 text-sm font-semibold text-[#E05915]" data-testid="category-paused-browse">
      Browse available flooring →
    </Link>
  </div>
);
